import { SelectItem } from 'components/inputs/select/select';

export const KEYS = {
  TIMEZONE_PREFIX: 'UTC',
};

export const formatTimezoneSelectItem = (offset: number): SelectItem => {
  const sign = offset >= 0 ? '+' : '-';
  const hours = String(Math.abs(offset)).padStart(2, '0');
  const formatted = `${sign}${hours}:00`;

  return {
    key: formatted,
    label: `${KEYS.TIMEZONE_PREFIX}${formatted}`,
  };
};

export const TIMEZONE_OPTIONS: SelectItem[] = [
  -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
].map((item) => formatTimezoneSelectItem(item));
